// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CompletionStatusType, TextModule } from '../../../../types/Model';

import { S } from './styles';

interface LabModuleProps {
  data: TextModule;
  status?: CompletionStatusType;
  handleNextModule: () => void;
}

const LabContent: React.FC<LabModuleProps> = ({ status, handleNextModule, data }):JSX.Element => {
  return (
    <S.Container>
      <S.Row>
        <S.InformationContainer>
          <S.TextImage />
          <S.Title>{data.name}</S.Title>
        </S.InformationContainer>
      </S.Row>
      <S.Row>
        {status === CompletionStatusType.COMPLETED && <S.Button onClick={handleNextModule}><FormattedMessage id="F015" /></S.Button>}
      </S.Row>
    </S.Container>
  );
}

export { LabContent as default };
